import { Box, Button, styled } from '@mui/material'

export const StyledSelect = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column'
}))

export const StyledSelectButton = styled(Button)(({ theme }) => ({
  // fontSize: 'clamp(12px,2vw,14px)',
  fontSize: 'clamp(10px,1vw,20px)',
  lineHeight: '1em',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  minWidth: 'clamp(80px, 10vw, 120px)',
  padding: '10px 10px'
}))

export const StyledSelectDropdownButton = styled(Button)(({ theme }) => ({
  borderRadius: '0',
  minWidth: '120px',
  ['&.active']: {
    color: 'var(--white)',
    backgroundColor: 'var(--light-blue)'
  }
}))
